<template>
  <a-button :loading="loading" @click="handleOk" class="reset"> 撤销 </a-button>
</template>

<script>
import { defineComponent } from "vue";
import { ApprovalFlowService } from "../approval-flow.service";
import { message } from "ant-design-vue";
import { useFlowEmitter } from "@/utils/emitter";
export default defineComponent({
  name: "submit-approval-btn",
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const { emitEvent } = useFlowEmitter();
    const { run } = ApprovalFlowService.useCancelApi();
    const handleOk = async () => {
      try {
        emit("update:loading", true);
        const { bizId, bizType } = props;
        const data = {
          bizId,
          bizType,
        };
        let res = await run(data);
        if (res.respCode !== "0000") {
          // message.error(res.respDesc);
          return;
        }
        emitEvent(bizId);
        message.success(res.respDesc);
        emit("refresh", null);
      } finally {
        emit("update:loading", false);
      }
    };
    return {
      handleOk,
    };
  },
});
</script>

<style scoped lang="less">
.reset {
  border: 1px solid #d9d9d9 !important;
  background-color: #f2f5fa !important;
  &:hover {
    border: 1px solid #2f7bff !important;
    color: #2f7bff !important;
  }
}
</style>
